import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
  selector: '[appInputRestriction]',
})
export class InputRestrictionDirective {
  inputElement: ElementRef;

  @Input('appInputRestriction') appInputRestriction: any;
  arabicRegex = '[\u0600-\u06FF]';

  constructor(private el: ElementRef<HTMLInputElement>) {
    this.inputElement = el;
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: any) {
    if (this.appInputRestriction === 'integer') {
      this.integerOnly(event);
    } else if (this.appInputRestriction === 'postalCode') {
      this.postalCode(event);
    }
    else if (this.appInputRestriction === 'alphaOnly') {
      this.alphaOnly(event);
    }
    else if (this.appInputRestriction === 'interFloat') {
      this.numberOrFloatOnly(event);
    }
    else if (this.appInputRestriction === 'noSpecialChars') {
      this.noSpecialChars(event);
    } else if (this.appInputRestriction === 'legalNameSpecialChars') {
      this.arabicRegex = '[\u0600-\u06FF, .\\-()_@&/]';
      this.noSpecialChars(event);
    } else if (this.appInputRestriction === 'email') {
      this.arabicRegex = '[\u0600-\u06FF, .@\\-_]';
      this.noSpecialChars(event);
      // Prevent space
      const e = <KeyboardEvent>event;
      if (e.key === ' ') {
        e.preventDefault();
      }
    } else if (this.appInputRestriction === 'websiteUrl') {
      this.arabicRegex = '[\u0600-\u06FF:/.&-]';
      this.noSpecialChars(event);
    } else if (this.appInputRestriction === 'Federal_Tax_ID') {
      this.federalTaxOnly(event);
    }

    // Check for more than one space
    const e = <KeyboardEvent>event;
    const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
    const inputValue = target?.value;
    const pressedKey = e.key;

    if (
      (pressedKey === ' ' &&
        /\s/.test(inputValue.charAt(inputValue.length - 1))) ||
      /\s{2,}/.test(inputValue)
    ) {
      e.preventDefault();
    }
  }



  integerOnly(event: any) {
    const e: any = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB' || e.key === 'n') {
      e.preventDefault();
      return;
    }

    const inputValue = e.target.value;
    const dotIndex = inputValue.indexOf('.');
    if (dotIndex !== -1 && e.key === '.') {
      // Prevent more than one dot
      e.preventDefault();
    }

    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && e.ctrlKey === true) ||
      // Allow numbers and a single dot
      (e.key >= '0' && e.key <= '9') ||
      (e.key === '.' && dotIndex === -1)
    ) {
      return;
    }

    e.preventDefault();
  }

  postalCode(event: any) {
    const e: any = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB' || e.key === 'n') {
      e.preventDefault();
      return;
    }
    const postalCodeRegex: RegExp = /^[\d-]+$/;
    // Check if the pressed key or input value violates the postal code format
    if (
      e.key.match(/[A-Za-z0-9 ]/) === null ||
      !postalCodeRegex.test(event.target.value + e.key)
    ) {
      e.preventDefault();
    }
  }


  alphaOnly(event: any) {
    const e = <KeyboardEvent>event;

    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }

    const k = event.keyCode;
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32) {
      return; // Allow uppercase letters, lowercase letters, and backspace
    }

    e.preventDefault();
  }

  federalTaxOnly(event: any) {
    const e: any = <KeyboardEvent>event;

    if (
      e.key === 'Tab' ||
      e.key === 'TAB' ||
      [8, 9, 27, 13].includes(e.keyCode)
    ) {
      return;
    }

    if (
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode === 67 && e.ctrlKey === true) ||
      (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true) ||
      (e.key === '.' && !e.target.value.includes('-')) ||
      !['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-'].includes(e.key)
    ) {
      e.preventDefault();
    }
  }

  numberOrFloatOnly(event: any) {
    const e = <KeyboardEvent>event;

    // Allow navigation keys
    if (e.key === 'Tab' || e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      return;
    }

    // Allow digits
    if (/^[0-9]$/.test(e.key)) {
      return;
    }

    // Allow one decimal point if not already present
    if (e.key === '.' && e.key.includes('.')) {
      return;
    }

    // Block everything else
    event.preventDefault();
  }


  noSpecialChars(event: any) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode; // k = event.charCode;  (Both can be used)
    if (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k === 8 ||
      k === 32 ||
      (k >= 48 && k <= 57)
    ) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }


  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    try {
      event.preventDefault(); // Prevent default paste behavior

      const clipboardData = event.clipboardData || (window as any).clipboardData;
      const pastedText = clipboardData.getData('text');

      let regex: RegExp = /.*/; // Default: allow all
      if (this.appInputRestriction === 'integer') {
        regex = /[0-9.]/g;
      }
      else if (this.appInputRestriction === 'interFloat') {
        regex = /^[0-9]+(\.[0-9]+)?$/;
      }
      else if (this.appInputRestriction === 'alphaOnly') {
        regex = /[A-Za-z]/g;
      } else if (this.appInputRestriction === 'noSpecialChars') {
        regex = /[a-zA-Z0-9\u0600-\u06FF]/g;
      } else if (this.appInputRestriction === 'legalNameSpecialChars') {
        regex = /[a-zA-Z0-9\u0600-\u06FF, .\-\(\)_/@&]/g;
      } else if (this.appInputRestriction === 'email') {
        regex = /[a-zA-Z0-9\u0600-\u06FF, .@]/g;
      } else if (this.appInputRestriction === 'websiteUrl') {
        regex = /[a-zA-Z0-9\u0600-\u06FF:/.&-]/g;
      }

      // Clean pasted text using regex
      const cleanedText = pastedText.match(regex)?.join('') || '';

      // Insert cleaned text into the input at cursor position
      const input = this.el.nativeElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const originalValue = input.value;

      input.value = originalValue.substring(0, start) + cleanedText + originalValue.substring(end);

      // Set caret position
      const caretPosition = start + cleanedText.length;
      input.setSelectionRange(caretPosition, caretPosition);

      // Optional: update Angular forms
      input.dispatchEvent(new Event('input'));
    } catch (error) {
      console.error(error)
    }
  }
}
